module.exports = "img/newmessages.972e9a3.png";